import React from 'react';

interface OwnProps {
  title: string;
  informations: { key: string; value: string }[];
}

const PlanInfoRowBase = (props: OwnProps) => {
  const { title, informations = [] } = props;
  const planInfoKeyList = informations.map(info => {
    const { key, value } = info;
    return (
      <div className="flex flex-col w-[170px]" key={key}>
        <dt className="text-sm font-bold">{value}</dt>
        <dd className="text-xs text-neutral-500">{key.toUpperCase()}</dd>
      </div>
    );
  });

  return (
    <div className="flex flex-col w-full gap-3">
      {title && <h2 className="text-sm font-bold text-blue-500">{title}</h2>}
      <div className="flex gap-2 w-full">{planInfoKeyList}</div>
    </div>
  );
};

export default PlanInfoRowBase;
